module.exports = "/0e8d9e4c10ecc96ae93aaa2b69d940f1c8363bc3/841a85ee6d1c7e2574d87175354b0321.svg";